ko.bindingHandlers.selectPicker = {
    after: ['options', 'value'],   /* KO 3.0 feature to ensure binding execution order */
    init: function (element, valueAccessor, allBindingsAccessor) {
        const initOptions = allBindingsAccessor.get('selectInitOpts');
        const ajax = allBindingsAccessor.get('ajaxSelectPicker') === true;

        var $element = $(element);
        $element.addClass('selectpicker').selectpicker(initOptions);

        if (ajax) {
            $element.ajaxSelectPicker(initOptions);
        }

        var doRefresh = function (v) {
            if (ko.options.deferUpdates) {
                $element.selectpicker('refresh');
                ko.tasks.schedule(function () {
                    $element.selectpicker('refresh');
                });

            } else {
                $element.selectpicker('refresh');
            }
        }, subscriptions = [];

        // KO 3 requires subscriptions instead of relying on this binding's update
        // function firing when any other binding on the element is updated.

        // Add them to a subscription array so we can remove them when KO
        // tears down the element.  Otherwise you will have a resource leak.
        var addSubscription = function (bindingKey) {
            var targetObs = allBindingsAccessor.get(bindingKey);

            if (targetObs && ko.isObservable(targetObs)) {
                subscriptions.push(targetObs.subscribe(doRefresh));
            }
        };

        addSubscription('options');
        addSubscription('value');           // Single
        addSubscription('selectedOptions'); // Multiple

        ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
            while (subscriptions.length) {
                subscriptions.pop().dispose();
            }
            //$element.removeClass('selectpicker').selectpicker('destroy');
        });

        doRefresh();
    },
    update: function (element, valueAccessor, allBindingsAccessor) {
        //var $element = $(element);
        //$element.removeClass('selectpicker').selectpicker('destroy');
        ////$element.selectpicker();
        //console.log('update a');
    }
};